import React, { useState } from "react";
import { Icon, IconButton, makeStyles, Tooltip } from "@material-ui/core";
import { isArray, isEmpty, isNil } from "lodash";
import { useTranslation } from "react-i18next";

import { commonIcon } from "../../pages/HomeStyles";
import AddNewItemToBandDialog from "./AddNewItemToBandDialog";
import { useAccessesStore } from "../../../../core/stores/AccessesStore";

const useStyles = makeStyles(() => ({
  buttonAddItemInBand: {
    marginLeft: 10,
    height: 30,
    width: 30,
    backgroundColor: "transparent",
    color: "#FFF",
    border: "2px dashed #FFF",
    position: "absolute",
    bottom: 5,
    right: 5,
    borderRadius: 4,
  },
}));

export default function AddNewItemToBand({ bandName, sectionIndex }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [openAddNewItemDialog, setOpenAddNewItemDialog] = useState(false);

  const handleOpenAddNewItemDialog = (to) => {
    setOpenAddNewItemDialog(to);
  };

  const { isEditing, menuItems } = useAccessesStore((state) => ({
    isEditing: state.isEditing,
    menuItems: state.menuItems,
  }));

  return (
    <>
      <Tooltip title={t("CUSTOM_HOME_ADD_ITEM_BAND")} placement="right">
        <IconButton
          className={classes.buttonAddItemInBand}
          onClick={() => handleOpenAddNewItemDialog(true)}
        >
          <Icon className="fas fa-plus" style={commonIcon} />
        </IconButton>
      </Tooltip>
      {isEditing &&
        openAddNewItemDialog &&
        !isNil(menuItems) &&
        !isEmpty(menuItems) &&
        isArray(menuItems) && (
          <AddNewItemToBandDialog
            open={openAddNewItemDialog}
            handleOpenAddNewItemDialog={handleOpenAddNewItemDialog}
            menuItems={menuItems}
            sectionIndex={sectionIndex}
            bandName={bandName}
          />
        )}
    </>
  );
}
